const getDataFromLocalStorage = (key) => {
	return window.localStorage.getItem(key);
};

const setDataToLocalStorage = (key, value) => {
	window.localStorage.setItem(key, value);
};

const isBuildVersionUpdated = (currentBuildVersion) => {
	return currentBuildVersion !== getDataFromLocalStorage('buildVersion');
};

export const clearCacheOnNewBuild = (currentBuildVersion) => {
	if (isBuildVersionUpdated(currentBuildVersion)) {
		// eslint-disable-next-line no-console
		console.log('New version found.');
		setDataToLocalStorage('buildVersion', currentBuildVersion);
		if ('caches' in window) {
			caches.keys().then((keyList) => {
				return Promise.all(
					keyList.map((key) => {
						return caches.delete(key);
					}),
				);
			});
		}
		window.location.reload();
	}
};
